const tickerItems = [
  "夜市人气现场队伍排出三条街",
  "大屏观赛区沸腾瞬间实拍",
  "新店开业围观人群里三层外三层",
  "跨年倒计时人群已开始聚集",
  "快闪活动现场围堵第一视角",
  "关键一球看台集体原地蹦起",
  "散场后回头讨论仍在继续",
  "同一瓜点多个现场同步记录",
];

export default function LiveTicker() {
  return (
    <div className="relative z-10 border-y border-background-200/70 bg-background-100">
      <div className="shell flex items-center gap-4 overflow-hidden py-3">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-semibold text-primary-600">
          <i className="ri-radar-line"></i>
          现场快讯
        </span>
        <div className="relative flex flex-1 items-center overflow-hidden">
          <div className="animate-marquee flex w-max shrink-0 items-center">
            {[...tickerItems, ...tickerItems].map((t, i) => (
              <span
                key={i}
                className="flex items-center gap-3 whitespace-nowrap pr-10 text-sm text-foreground-700"
              >
                <i className="ri-record-circle-line text-[10px] text-accent-500"></i>
                {t}
              </span>
            ))}
          </div>
        </div>
        <a
          href="#topics"
          className="hidden shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600 md:inline-flex"
        >
          更多
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </div>
  );
}